import React from 'react';
import { Container } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Header from './components/Header';
import Footer from './components/Footer';

import './style/page.css';
import './style/icons.css';

export default function Page({ footer, header, children }) {
  return (
    <>
      {header && <Header />}
      <Container className="page-container">{children}</Container>
      {footer && <Footer />}
    </>
  );
}

Page.propTypes = {
  children: PropTypes.node,
  footer: PropTypes.bool,
  header: PropTypes.bool,
};

Page.defaultProps = {
  footer: true,
  header: true,
  children: null,
};
